/* LenBlu® — efectos firma. Todo se inicializa una sola vez por elemento
   (guardado con data-lb-ready) y se re-ejecuta al recargar secciones en el editor. */
(function () {
  if (window.__lbLoaded) return;
  window.__lbLoaded = true;
  document.documentElement.classList.add('lb-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function once(el, key) {
    if (el.dataset['lb' + key]) return false;
    el.dataset['lb' + key] = '1';
    return true;
  }

  /* Aparición al hacer scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function reveal(root) {
    root.querySelectorAll('[data-lb-reveal], [data-lb-clip]').forEach(function (el) {
      if (!once(el, 'Rev')) return;
      if (!io || reduce) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* Efectos ligados al scroll (un solo bucle) */
  var scrollers = [];
  function onScroll() {
    var vh = window.innerHeight;
    scrollers.forEach(function (fn) { fn(vh); });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { onScroll(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', onScroll);

  function clamp(v) { return Math.max(0, Math.min(1, v)); }

  function heroes(root) {
    root.querySelectorAll('.lb-hero').forEach(function (el) {
      if (!once(el, 'Hero')) return;
      requestAnimationFrame(function () { el.classList.add('is-loaded'); });
    });
  }

  /* LENS + BLUE → LENBLU */
  function names(root) {
    root.querySelectorAll('.lb-name__stage').forEach(function (el) {
      if (!once(el, 'Name')) return;
      if (reduce) { el.style.setProperty('--p', 1); return; }
      var speed = parseFloat(el.dataset.speed || '1');
      scrollers.push(function (vh) {
        var r = el.getBoundingClientRect();
        // 0 cuando entra por abajo, 1 cuando su centro llega al 40 % de la pantalla
        var start = vh * 0.95, end = vh * 0.4;
        var mid = r.top + r.height / 2;
        var p = clamp(((start - mid) / (start - end)) * speed);
        el.style.setProperty('--p', p.toFixed(3));
      });
    });
  }

  /* Paralaje suave en imágenes editoriales */
  function parallax(root) {
    root.querySelectorAll('[data-lb-parallax]').forEach(function (img) {
      if (!once(img, 'Par') || reduce) return;
      var k = parseFloat(img.dataset.lbParallax || '0.2');
      scrollers.push(function (vh) {
        var box = img.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh) return;
        var c = (box.top + box.height / 2 - vh / 2) / vh;
        img.style.transform = 'translate3d(0,' + (c * k * -100).toFixed(2) + 'px,0)';
      });
    });
  }

  /* La lente: capas que se separan con el scroll y se iluminan al pasar */
  function lenses(root) {
    root.querySelectorAll('.lb-lens').forEach(function (sec) {
      if (!once(sec, 'Lens')) return;
      var stack = sec.querySelector('.lb-lens__stack');
      var items = sec.querySelectorAll('.lb-lens__item');
      if (!stack) return;
      var maxSep = parseFloat(stack.dataset.sep || '1');
      if (reduce) stack.style.setProperty('--sep', maxSep);
      else scrollers.push(function (vh) {
        var r = sec.getBoundingClientRect();
        var p = clamp((vh - r.top) / (vh + r.height * 0.35));
        stack.style.setProperty('--sep', (Math.sin(p * Math.PI) * maxSep * 1.15).toFixed(3));
      });
      function activate(i) {
        stack.dataset.active = i;
        items.forEach(function (it, j) { it.classList.toggle('is-active', j + 1 === i); });
      }
      items.forEach(function (it, j) {
        it.addEventListener('mouseenter', function () { activate(j + 1); });
        it.addEventListener('focusin', function () { activate(j + 1); });
      });
      if (io) {
        var io2 = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) activate(Array.prototype.indexOf.call(items, e.target) + 1); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        items.forEach(function (it) { io2.observe(it); });
      }
    });
  }

  /* Carriles horizontales: flechas alineadas + reloj del día */
  function tracks(root) {
    root.querySelectorAll('[data-lb-track]').forEach(function (wrap) {
      if (!once(wrap, 'Track')) return;
      var track = wrap.querySelector('.lb-track');
      var prev = wrap.querySelector('[data-lb-prev]');
      var next = wrap.querySelector('[data-lb-next]');
      var clock = wrap.querySelector('[data-lb-clock]');
      var bar = wrap.querySelector('.lb-day__clock-bar');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      function current() {
        var left = track.scrollLeft, best = 0, bestD = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - slides[0].offsetLeft - left);
          if (d < bestD) { bestD = d; best = i; }
        });
        return best;
      }
      function go(dir) {
        var i = Math.max(0, Math.min(slides.length - 1, current() + dir));
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        var i = current();
        if (clock && slides[i] && slides[i].dataset.time) clock.textContent = slides[i].dataset.time;
        if (bar) bar.style.setProperty('--lb-prog', (max > 0 ? 10 + (track.scrollLeft / max) * 90 : 100) + '%');
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* Galería de producto en móvil: puntos */
  function pdp(root) {
    root.querySelectorAll('.lb-pdp__gallery').forEach(function (g) {
      if (!once(g, 'Pdp')) return;
      var dots = g.parentElement.querySelectorAll('.lb-pdp__dots i');
      if (!dots.length) return;
      g.addEventListener('scroll', function () {
        var i = Math.round(g.scrollLeft / g.clientWidth);
        dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
      }, { passive: true });
    });
  }

  /* Portada cine: fotos que se suceden solas */
  function slideshows(root) {
    root.querySelectorAll('[data-lb-slides]').forEach(function (sec) {
      if (!once(sec, 'Slides')) return;
      var slides = sec.querySelectorAll('.lb-hero2__slide');
      var dots = sec.querySelectorAll('.lb-hero2__dot');
      if (slides.length < 2) return;
      var ms = parseInt(sec.dataset.lbSlides, 10) || 6000;
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
        dots.forEach(function (d, j) {
          d.classList.remove('is-active');
          void d.offsetWidth; // reinicia la barra de progreso
          if (j === i) d.classList.add('is-active');
        });
      }
      function play() { clearInterval(timer); if (!reduce) timer = setInterval(function () { show(i + 1); }, ms); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () { show(parseInt(d.dataset.lbGo, 10)); play(); });
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearInterval(timer); else play(); });
      if (sec.hasAttribute('data-lb-random')) show(Math.floor(Math.random() * slides.length));
      play();
    });
  }

  /* Manifiesto: las palabras se iluminan al bajar */
  function manifestos(root) {
    root.querySelectorAll('[data-lb-words]').forEach(function (p) {
      if (!once(p, 'Words')) return;
      var spans = p.querySelectorAll('span');
      if (reduce) { spans.forEach(function (s) { s.classList.add('is-lit'); }); return; }
      scrollers.push(function (vh) {
        var r = p.getBoundingClientRect();
        var prog = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35));
        var n = Math.round(prog * spans.length);
        spans.forEach(function (s, j) { s.classList.toggle('is-lit', j < n); });
      });
    });
  }

  /* Cifras que cuentan */
  function counters(root) {
    root.querySelectorAll('[data-lb-count]').forEach(function (el) {
      if (!once(el, 'Count')) return;
      var target = parseFloat(el.dataset.lbCount);
      if (isNaN(target) || reduce || !io) return;
      var dec = (el.dataset.lbCount.split('.')[1] || '').length;
      el.textContent = (0).toFixed(dec);
      var obs = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.disconnect();
          var t0 = performance.now(), dur = 1600;
          (function tick(t) {
            var k = Math.min(1, (t - t0) / dur);
            var v = target * (1 - Math.pow(1 - k, 3));
            el.textContent = v.toFixed(dec);
            if (k < 1) requestAnimationFrame(tick);
          })(t0);
        });
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  function init(root) {
    root = root || document;
    reveal(root); heroes(root); names(root); parallax(root); lenses(root); tracks(root); pdp(root);
    slideshows(root); manifestos(root); counters(root);
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
